import { useMemo } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { PageLayout } from '@/components/shared/PageLayout';
import { PageHeader } from '@/components/shared/PageHeader';
import { useTranslation } from '@/hooks/useTranslation';
import { DashboardGrid } from './DashboardGrid';

export function Home() {
  const { tokenService } = useAuth();
  const { t } = useTranslation();

  const email = tokenService?.getUserMail() ?? null;
  const modules = useMemo(() => tokenService?.getModules() ?? [], [tokenService]);

  return (
    <PageLayout contentClassName="max-w-5xl">
      <PageHeader
        title={
          <>
            {t('home.dashboard.welcome')}
            {email != null && (
              <span className="ml-2 font-normal text-muted-foreground">{email}</span>
            )}
          </>
        }
        description={t('home.dashboard.description')}
      />

      <DashboardGrid modules={modules} />
    </PageLayout>
  );
}
